<div id="cutomer-profile-screen" (window:orientationchange)="changeOrientation($event)"
    [ngStyle]="{'height.px':divHeight1}">
    <div class="row" [ngStyle]="{'height.px':divHeight1}">
        <div class="col-md-6" id="progress-tracker" [ngStyle]="{'height.px':divHeight1}">
            <div id="heading">
                <h1 *ngIf="showHeading"><strong>{{cfetLabels.cfet_customer_profile.heading}}</strong></h1>
                <h1 id="step-done-heading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_heading}}</strong>
                </h1>
                <h1 id="step-done-subheading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_subheading}}</strong>
                </h1>
            </div>
            <div id="all-track">
                <div class="row" id="track1">
                    <div class="col-lg-1" id="circle">
                        <button [ngClass]="stepOneSelected ? 'btn1-selected' : 'btn1'" id="btn1-desc">
                            <p id="btn-no" class="btn-completed">&#10003;</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepOneSelected ? 'static-text1-selected' : 'static-text'" id="static-text-decs">
                            {{cfetLabels.cfet_customer_eligibility.eligibility}}
                            <em *ngIf="showDesktopEditButton" class="icon-misc-penL" role="img" aria-label="Edit"
                                id="icon-role"></em>
                        </p>
                    </div>
                    <div *ngIf="showMobileEditButton">
                        <em class="icon-misc-penL" role="img" aria-label="Edit Button" id="icon-mobile-role"
                            tabindex="0"></em>
                    </div>
                </div>
                <div id="show-workplace-section" *ngIf="showWorkPlaceSection">
                    <div class="row">
                        <div class="col-md-10 role-mobile-max">
                            <div class="selected-role">
                                <label class="selected-role-heading">{{selectedRole}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="dividercomp section">
                        <div class="row" id="action-divider"></div>
                    </div>
                    <div class="row">
                        <div class="col-md-10 role-mobile-max">
                            <div class="selected-workplace">
                                <label class="selected-workplace-name">{{selectedWorkPlace}}</label>
                                <p class="selected-workplace-address">{{selectedAddress}}, {{selectedCity}},
                                    {{selectedStateInWorkplace}} {{selectedZipInWorkplace}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <span [ngClass]="stepOneDone? 'solid-line': 'dashed-line'" id="vertical-line1"></span>
                <div class="row" id="track2">
                    <div class="col-lg-1" id="circle">
                        <button id="btn2-desc" [ngClass]="stepTwoSelected ? 'btn2-selected' : 'btn1' "
                            [disabled]="disableStep">
                            <p *ngIf="stepTwoDone" id="btn-no" class="btn-completed">&#10003;</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepTwoSelected ? 'static-text2-selected' : 'static-text'" id="static-text-desc2">
                            {{cfetLabels.cfet_customer_eligibility.information}}</p>
                    </div>
                </div>
                <div [ngClass]="stepTwocompleted? 'solid-line': 'dashed-line'" id="vertical-line1" id="vertical-line2">
                </div>
                <div class="row" id="track3">
                    <div class="col-lg-1" id="circle">
                        <button id="btn3-desc" [ngClass]="stepThreeSelected ? 'btn3-selected' : 'btn1' "
                            [disabled]="disableStep" (click)="stepThree()">
                            <p *ngIf="stepThreeIcon" id="btn-no">3</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepThreeSelected ? 'static-text3-selected' : 'static-text'" (click)="stepThree()"
                            id="static-text-desc3">{{cfetLabels.cfet_customer_eligibility.profile}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6" id="form-component-section">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8" *ngIf="showPasswordScreen">
                    <app-complete-profile-form (openTermsPage)="openTermsPage($event)"
                        (showCodeSection)="showCodeSection($event)" [showWeekPassword]="showWeekPassword">
                    </app-complete-profile-form>
                </div>
                <div class="col-md-8" *ngIf="showOTPScreen">
                    <app-customer-profile-form (showCompleteProfile)="showCompleteProfile($event)">
                    </app-customer-profile-form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
        <div id="terms-conditions" *ngIf="showTermsAndCondition">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="terms-heading">
                        <p id="terms_heading">{{cfetLabels.cfet_terms_condition.heading}}</p>
                    </div>
                    <div class="terms-date">
                        <p>{{cfetLabels.cfet_terms_condition.terms_date}}</p>
                        <p>{{cfetLabels.cfet_terms_condition.terms_date1}}</p>
                    </div>
                    <div class="terms-intro">
                        <p><strong>{{cfetLabels.cfet_terms_condition.introduction}}</strong></p>
                    </div>
                    <div class="terms-desc">
                        <p id="desc1">{{cfetLabels.cfet_terms_condition.desc1}}</p>
                        <p id="desc2">{{cfetLabels.cfet_terms_condition.desc2}}</p>
                        <p id="desc3">{{cfetLabels.cfet_terms_condition.desc3}}</p>
                        <p id="info1" [innerHTML]="cfetLabels.cfet_terms_condition.info1"></p>
                        <p id="info2" [innerHTML]="cfetLabels.cfet_terms_condition.info2"></p>
                        <p id="info3" [innerHTML]="cfetLabels.cfet_terms_condition.info3"></p>
                        <p id="info4" [innerHTML]="cfetLabels.cfet_terms_condition.info4"></p>
                        <p id="info5" [innerHTML]="cfetLabels.cfet_terms_condition.info5"></p>
                        <p id="sub_info5" [innerHTML]="cfetLabels.cfet_terms_condition.sub_info5"></p>
                        <p id="info6" [innerHTML]="cfetLabels.cfet_terms_condition.info6"></p>
                        <p id="info7" [innerHTML]="cfetLabels.cfet_terms_condition.info7"></p>
                        <p id="info8" [innerHTML]="cfetLabels.cfet_terms_condition.info8"></p>
                        <p id="info9" [innerHTML]="cfetLabels.cfet_terms_condition.info9"></p>
                        <p id="info10" [innerHTML]="cfetLabels.cfet_terms_condition.info10"></p>
                        <p id="info11" [innerHTML]="cfetLabels.cfet_terms_condition.info11"></p>
                        <p id="info12" [innerHTML]="cfetLabels.cfet_terms_condition.info12"></p>
                        <p id="info13" [innerHTML]="cfetLabels.cfet_terms_condition.info13"></p>
                        <p id="info14" [innerHTML]="cfetLabels.cfet_terms_condition.info14"></p>
                        <p id="info15" [innerHTML]="cfetLabels.cfet_terms_condition.info15"></p>
                        <p id="info16" [innerHTML]="cfetLabels.cfet_terms_condition.info16"></p>
                        <p id="general_info1" [innerHTML]="cfetLabels.cfet_terms_condition.general_info1"></p>
                        <p id="general_info2" [innerHTML]="cfetLabels.cfet_terms_condition.general_info2"></p>
                        <p id="general_info3" [innerHTML]="cfetLabels.cfet_terms_condition.general_info3"></p>
                    </div>
                </div>
                <div class="col-md-3 terms-close-icon">
                    <picture>
                        <source media="(min-width: 280px)" srcset="assets/images/Close_32px.png">
                        <img id="close-icon" (click)="closeTermsPage($event)" (keyup)="closeTermsPage($event)"
                            src="assets/images/Close_32px.png" alt="Close icon" tabindex="0">
                    </picture>
                </div>
            </div>
        </div>
    </div>
</div>